/**
 * Slim catalog of mini-lessons · metadata only (no MDX body).
 * Imported eagerly by `BonusLessonsWidget` (Dashboard) and `useAchievements`
 * so the full lesson bodies (~21 KB raw) stay out of the initial bundle and
 * ride only with the lazy `MiniLesson` screen chunk.
 *
 * KEEP IN SYNC with `miniLessons.ts`. The `catalog-sync.test.ts` invariant
 * will fail in `npm run verify` if any metadata field drifts.
 */

export interface MiniLessonMeta {
  id: string;
  title: string;
  emoji: string;
  durationMin: number;
  relatedSprint: number;
  unlockBadgeId: string;
  unlockLabel: string;
}

export const MINI_LESSONS_META: ReadonlyArray<MiniLessonMeta> = [
  {
    id: 'ml-sbtm-deepdive',
    title: 'SBTM · 4 modes vs Linear planning',
    emoji: '🔍',
    durationMin: 6,
    relatedSprint: 3,
    unlockBadgeId: 'detective-senior',
    unlockLabel: 'Detective Senior · 15+ Investigate scenarios',
  },
  {
    id: 'ml-bva-gotchas',
    title: 'BVA · 7 классических ошибок junior на собесе',
    emoji: '🎯',
    durationMin: 7,
    relatedSprint: 5,
    unlockBadgeId: 'author-apprentice',
    unlockLabel: 'Author Apprentice · 5+ Author tasks (BVA submitted в PR-27 для контекста)',
  },
  {
    id: 'ml-ai-antipatterns',
    title: 'AI testing antipatterns · 5 traps',
    emoji: '🤖',
    durationMin: 7,
    relatedSprint: 4,
    unlockBadgeId: 'author-apprentice',
    unlockLabel: 'Author Apprentice · 5+ Author tasks (AI critique tasks contextualize)',
  },
  {
    id: 'ml-dt-overkill',
    title: 'Decision Tables · мощно но 90% времени overkill',
    emoji: '📊',
    durationMin: 5,
    relatedSprint: 5,
    unlockBadgeId: 'author-senior',
    unlockLabel: 'Author Senior · 15+ Author tasks (DT contexts из PR-28)',
  },
  {
    id: 'ml-br-recruiter',
    title: 'Bug Report · 5 patterns · что recruiter увидит',
    emoji: '🐛',
    durationMin: 6,
    relatedSprint: 4,
    unlockBadgeId: 'author-apprentice',
    unlockLabel: 'Author Apprentice · 5+ Author tasks (BR submitted в PR-22 для контекста)',
  },
  {
    id: 'ml-charter-art',
    title: 'Test Charter · искусство short prose',
    emoji: '✍️',
    durationMin: 5,
    relatedSprint: 3,
    unlockBadgeId: 'detective-junior',
    unlockLabel: 'Detective Junior · 5+ Investigate scenarios (Charter writing context)',
  },
];
